import { useEffect, useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMoneyBill,
  faCalendarWeek,
  faCalendarAlt,
  faLineChart,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../../Auths/CheckUser";
import { Link } from "react-router-dom";

const AirArrears = () => {
  const { user } = useAuth();
  const [activeArrears, setActiveArrears] = useState(0);
  const [weeklyArrears, setWeeklyArrears] = useState(0);
  const [monthlyArrears, setMonthlyArrears] = useState(0);

  useEffect(() => {
    if (!user || !user.id) return;

    const fetchStaffClients = async () => {
      try {
        const res = await axios.get(`https://globizsystems.click/api/user/${user.id}`);
        const staffData = res.data;

        const clientList = Array.isArray(staffData.airclients) ? staffData.airclients : [];
        calculateArrearsTotals(clientList);
        calculateWeeklyMonthly(clientList);
      } catch (err) {
        console.error("Error fetching staff clients:", err);
      }
    };

    fetchStaffClients();
  }, [user]);

  const calculateArrearsTotals = (records) => {
    let active = 0;

    records.forEach((item) => {
      const arrears = item.arrears || 0;
      if (item.status === "AKTIF" || item.status === "Active") active += arrears;
    });

    setActiveArrears(active);
  };

  const calculateWeeklyMonthly = (records) => {
    const now = new Date();
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay());
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    let weeklyActive = 0;
    let monthlyActive = 0;

    records.forEach((item) => {
      if (!item.createdAt) return;
      const date = new Date(item.createdAt);
      const arrears = item.arrears || 0;

      if (date >= startOfWeek && date <= endOfWeek && (item.status === "AKTIF" || item.status === "Active")) {
        weeklyActive += arrears;
      }

      if (date >= startOfMonth && date <= endOfMonth && (item.status === "AKTIF" || item.status === "Active")) {
        monthlyActive += arrears;
      }
    });

    setWeeklyArrears(weeklyActive);
    setMonthlyArrears(monthlyActive);
  };

  return (
    <div className="min-h-screen  bg-gray-50">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-gray-800">Laporan Air</h3>
        <p className="text-gray-500 text-sm mt-1">Staff: {user?.name}</p>
      </div>

      

      {/* Active Arrears Card */}
      <div className="bg-gradient-to-r from-blue-500 to-sky-600 p-4 rounded-xl shadow-md mb-6 text-white hover:scale-[1.01] transition-transform duration-300">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-sm font-medium">Jumlah Tunggakan Aktif</h3>
            <p className="text-2xl font-bold mt-1">RM {activeArrears.toFixed(2)}</p>
          </div>
          <div className="bg-white/20 p-3 rounded-full">
            <FontAwesomeIcon icon={faMoneyBill} className="text-white text-xl" />
          </div>
        </div>
      </div>

      {/* Weekly Report (Active Only) */}
      <div className="bg-white p-4 rounded-xl shadow-md mt-6">
        <div className="flex items-center mb-4">
          <FontAwesomeIcon icon={faCalendarWeek} className="text-blue-600 text-lg mr-2" />
          <h3 className="text-lg font-bold text-gray-800">Tunggakan Aktif Mingguan</h3>
        </div>

        <div className="bg-green-50 border border-green-200 p-4 rounded-lg">
          <h4 className="text-green-700 font-semibold text-base">Aktif</h4>
          <div className="flex justify-between items-center">
            <p className="text-xl font-bold mt-1 text-gray-800">
              RM {weeklyArrears.toFixed(2)}
            </p>
            <div className="p-3 rounded-full bg-green-500">
              <FontAwesomeIcon icon={faLineChart} className="text-white text-xl" />
            </div>
          </div>
        </div>
      </div>

      {/* Monthly Report (Active Only) */}
      <div className="bg-white p-4 rounded-xl shadow-md mt-6">
        <div className="flex items-center mb-4">
          <FontAwesomeIcon icon={faCalendarAlt} className="text-purple-600 text-lg mr-2" />
          <h3 className="text-lg font-bold text-gray-800">Tunggakan Aktif Bulanan</h3>
        </div>

        <div className="bg-green-50 border border-green-200 p-4 rounded-lg">
          <h4 className="text-green-700 font-semibold text-base">Aktif</h4>
          <div className="flex justify-between items-center">
            <p className="text-xl font-bold mt-1 text-gray-800">
              RM {monthlyArrears.toFixed(2)}
            </p>
            <div className="p-3 rounded-full bg-green-500">
              <FontAwesomeIcon icon={faLineChart} className="text-white text-xl" />
            </div>
          </div>
        </div>
      </div>

      {/* View Button */}
      <div className="flex justify-center m-5">
        <Link to="/arrears-air-actives">
          <button className="py-2 px-3 rounded-lg bg-green-500 text-white hover:bg-green-600 transition-colors">
            Lihat Jadual
          </button>
        </Link>
      </div>
    </div>
  );
};

export default AirArrears;
